import { styled, Tabs, TabsProps } from "@mui/material";

const ColorTabsCore = styled(Tabs)(({ theme }) => ({
	backgroundColor: theme.palette.primary.main,
	color: theme.palette.primary.contrastText,
}));

export type ColorTabsProps = TabsProps;

export const ColorTabs = (props: ColorTabsProps): JSX.Element => (
	<ColorTabsCore indicatorColor="secondary" textColor="inherit" {...props} />
);
